export enum CanvasMode {
	LineDrawing,
	Text
}
